const Algorithms = [
  // Blobbys
  (x, y, t, m) => {
    const modA = map(m.a, 0, 1, -0.125, 0.125);
    const modB = map(m.b, 0, 1, -0.125, 0.125);
    const modC = map(m.c, 0, 1, 0.11, 0.45);
    return cos((x + t * modA) * modC) * cos((y + t * modB) * modC) * 0.1 + t * 0.5;
  },

  // Moving eye
  (x, y, t, m) => {
    const modA = map(m.a, 0, 1, 5, window.grid.x / 2);
    const modB = map(m.b, 0, 1, 1, 20);
    const modC = map(m.c, 0, 1, t * -2, t *2);
    const modD = map(m.d, 0, 1, t * -2, t *2);
    return abs(sin(x / modA + modC) + 1 * cos(y / modA + modD) + 1 * modB);
  },

  // Sliders
  (x, y, t, m) => {
    const modB = map(m.b, 0, 1, 1, 5);
    const modC = map(m.c, 0, 1, 1, 5);
    const axisX = sin(x / modB / window.grid.x + t);
    const axisY = sin(y / modC / window.grid.y + t);

    switch (floor(m.a * 3)) {
      case 0:
        return axisX;
      case 1:
        return axisY;
      default:
        return axisX * axisY;
    }
  },

  // Back+forth dance
  (x, y, t, m) => {
    const modA = map(m.a, 0, 1, 15, 40);
    const modB = map(m.b, 0, 1, 15, 40);
    return cos(x / modA + t) + sin(y / modB + t) + t;
  },

  // Lavalamp
  (x, y, t, m) => {
    const direction = (m.a < 0.5) ? x : y;
    const axis = (m.b < 0.5) ? window.grid.x : window.grid.y;
    const modC = map(m.c, 0, 1, 1, 6);
    return sin(direction / axis / modC + t);
  },

  // Pond ripples
  (x, y, t, m) => {
    // Band freq
    const modA = map(m.a, 0, 1, 0.06, 0.3);
    // Band thinkness
    const modB = map(m.b, 0, 1, 0.1, 0.5)
    return sin(t - sqrt((x * x + y * y) * modB) * modA);
  },

  // Pulses from center
  (x, y, t, m) => {
    const modA = map(m.a, 0, 1, 0.05, 0.1);
    return t % window.grid.x - Math.hypot(x - window.grid.x / 2, y - grid.y / 2) * modA;
  },

  // Smoke
  (x, y, t) => ((x + 1) / (y + 1) / (x + 1)) - t,

  // Inverts
  (x, y, t) => (x - (window.grid.x / 2)) * (y - (window.grid.y / 2)) - sin(t),

  // Pin wheel
  (x, y, t, m) => {
    const modA = map(sin(t), -1, 1, 0.5, 1);
    const modB = map(m.b, 0, 1, 1, 4);
    const modC = (m.c < 0.5) ? -1 : 1;
    return sin(2 * atan((y - window.grid.y / 2) / (x - window.grid.x / 2)) + modB * modC * t) * modA;
  },

  // Take turns dance
  (x, y, t) => sin((y % 2) + t) * sin((x % 2) + t) / sin((y % 1) + t) * sin((x % 1) + t),

  // Simple back&forth
  (x, y, t) => sin(t),

  // Simple
  (x, y, t) => t,

  // Crosswork gird, even x&y only
  (x, y, t) => {
    return (x % 2 === 0 && y % 2 === 0) ? t : 0;
  },

  // Seashore
  (x, y, t, m) => {
    let axis = y;
    let edge = window.grid.y;
    if (m.a < 0.5) {
      axis = x;
      edge = window.grid.x;
     }
    const direction = (m.b < 0.5) ? edge - axis : axis;
    return Math.log(direction + 1) + t;
  },

  // Vertical alternatives
  (x, y, t) => abs(x / 2) + t,

  // Diagonal waves
  (x, y, t, m) => {
    const modA = (m.a < 0.5) ? x - y : x + y;
    const modB = (m.b < 0.5) ? -t : t;
    const modC = (m.c < 0.5) ? window.grid.x : window.grid.y;
    return modA / modC + modB;
  },

  // Poka dots
  (x, y, t, m) => {
    const modA = 3 * (round(m.a * 3) + 1);
    const modB = map(m.b, 0, 1, -200, 200);
    const modC = map(m.c, 0, 1, -200, 200);
    return cos((x + t / modB) * modA) * sin((y + t / modC) * modA) * sin(t) * 0.5 + t;
  },

  // Scroll horizontal
  (x, y, t, m) => {
    // Run rate
    const modA = map(m.a, 0, 1, 2, 5);
    // Direction
    const modB = (m.b < 0.5) ? t : -t;
    return (y / window.grid.y / modA + modB);
  },

  // Zebra lines
  (x, y, t, m) => {
    // Amout of strips
    const modA = map(m.a, 0, 1, 0.05, 0.3) * 0.13;
    // Spread of strips
    const modB = map(m.b, 0, 1, 1.2, 3);
    return (floor(x + y) * modA) / modB * HALF_PI + t;
  },

  // Cycles
  (x, y, t, m) => {
    const modA = map(m.a, 0, 1, 1, 3)
    const modB = map(m.b, 0, 1, 1, 3)
    return cos(t + (x / grid.x / modA)) + sin(t + (y / grid.y / modB));
  },

  // Flowing waves
  (x, y, t, m) => {
    const direction = (m.a < 0.5) ? window.grid.y / (y + 1) : window.grid.x / (x + 1);
    const modB = map(m.b, 0, 1, 1, 5);
    const modC = (m.c < 0.5) ? t : -t;
    return direction / modB + modC;
  },

  // Random flip swipe
  (x, y, t, m) => {
    const modA = (m.a < 0.5) ? t : -t;
    const modB = (m.b < 0.5) ? x + y : x - y;
    // p5 random seed, which comes from the token hash keeps this random value locked.
    return cos(modA + modB / (window.grid.x + random(10)));
  },

  // Alternating line
  (x, y, t, m) => {
    const modA = round(map(m.a, 0, 1, 1.5, 3) * 10) / 10;
    const direction = (m.b > 0.5) ? y : x;
    return (direction / modA) % window.grid.y + t;
  },

  // Runners
  (x, y, t, m) => {
    const modA = map(m.a, 0, 1, 0.2, 0.4);
    const modB = map(m.b, 0, 1, 0.2, 0.4);
    return sin(t - sqrt((x - (window.grid.x / modA)) * 2 + (y - (window.grid.y / modB)) ** 2));
  },

  // Fluttering flag
  (x, y, t, m) => {
    const modA = map(m.a, 0, 1, 50, 120);
    return abs(sin(x * modA)) * 0.1 + t;
  },

  // Glitch / error
  (x, y, t, m) => {
    const glitchSizeA = round(map(m.a, 0, 1, 5, 8) + t/100);
    const glitchSizeB = round(map(m.b, 0, 1, 5, 7) + t/100);
    const glitchSizeC = round(map(m.c, 0, 1, 70, 99) * 1.3);
    const glitchSizeD = m.d < 0.5 ? grid.y : grid.y + 1;
    return (x - grid.x / 2) ** glitchSizeA + (y - glitchSizeD / 2) ** glitchSizeB - glitchSizeC * sin(t / 50);
  },

  // Grids
  (x, y, t, m) => {
    const modA = round(window.grid.x / map(m.a, 0, 1, 3, 6));
    const modB = round(window.grid.y / map(m.b, 0, 1, 3, 5));
    return (x % modA && y % modB / HALF_PI) + t;
  },

  // 2x2 split grid
  (x, y, t, m) => {
    const modA = map(m.a, 0, 1, 1, 2.5);
    return round(x - window.grid.x / 2) * round(y - window.grid.y / 2) - sin(t) * modA;
  },

  // Inverted rectangle
  (x, y, t, m) => {
    const w = floor(map(m.a, 0, 1, 4, window.grid.x - 4));
    const h = floor(map(m.b, 0, 1, 2, window.grid.y - 2));
    const posX = window.grid.x / 2 - w / 2;
    const posY = window.grid.y / 2 - h / 2;
    return (x >= posX & y >= posY & x < posX + w & y < posY + h) * PI + t;
  },

  // Tiger skin (Perlin noise)
  (x, y, t, m) => {
    // X-axis
    const modA = map(m.a, 0, 1, -t, t);
    // Y-axis
    const modB = map(m.b, 0, 1, -t, t);
    // Z-axis
    const modC = map(m.c, 0, 1, -t, t);
    // Noise scale
    const modD = map(m.d, 0, 1, 5, 15);
    return map(constrain(noise(x / modD + modA, y / modD + modB, modC) * 10, 3.5, 6), 3.5, 6, 0, 1);
  },

  /*
   ** Unsure
  // Another corss work
  (x, y, t) => (y-window.grid.y*.5+t) * (x-window.grid.x*.5 + t)*.5,

  // Glitch/error. slow and fast
  (x, y, t) => sin(t / 10 * window.grid.x / 2) * tan(t / 20 * window.grid.y / 2),
  */
];

export default Algorithms;
